import { EditAssigneeContainer } from './EditAssignee.container'

interface EditAssigneeIdWrapperProps {
  id?: string
  setIsRequestRunning: (params: boolean) => void
  visible: boolean
  onHide: () => void
  mutate: () => void
}

export const EditAssigneeIdWrapper: React.FC<EditAssigneeIdWrapperProps> = ({
  id,
  mutate,
  setIsRequestRunning,
  visible,
  onHide,
}) => {
  if (!id) return null
  return (
    <EditAssigneeContainer
      setIsRequestRunning={setIsRequestRunning}
      id={id}
      visible={visible}
      onHide={onHide}
      mutate={mutate}
    />
  )
}
